import { ColumnsProps } from 'components/Table/Table'
import { getLineTypeByTheme, LINE_TYPES } from 'config/theme.config'
import i18n from 'i18n'

export const allColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'order',
    title: i18n.t('tables:orderNumber')
  },
  {
    align: 'right',
    fixed: true,
    name: 'cargo',
    title: i18n.t('tables:charge')
  },
  {
    align: 'right',
    fixed: true,
    name: 'industrydoc',
    title: i18n.t('tables:CNPJIndustrySlaughter')
  },
  {
    align: 'right',
    fixed: true,
    name: 'corporatename',
    title: i18n.t('tables:socialReasonSlaughter')
  },
  {
    align: 'right',
    name: 'state',
    title: i18n.t('tables:ufCNPJSlaughter')
  },
  {
    align: 'right',
    name: 'city',
    title: i18n.t('tables:municipalitySlaughter')
  },
  {
    align: 'right',
    name: 'slaughterinspectionnum',
    title: i18n.t('tables:slaughterSIF')
  },
  {
    align: 'right',
    name: 'slaughteredat',
    title: i18n.t('tables:slaughterDate')
  },
  {
    align: 'right',
    name: 'productcode',
    title: i18n.t('common:productCode')
  },
  {
    name: 'productdescription',
    title: i18n.t('common:productDescription')
  },
  {
    align: 'right',
    name: 'slaughterbatch',
    title: i18n.t('tables:slaughterBatch')
  },
  {
    align: 'right',
    name: 'sequential',
    title: i18n.t('tables:slaughterSequence')
  },
  {
    align: 'right',
    name: 'band',
    title: i18n.t('common:side')
  },
  {
    align: 'right',
    name: 'weight',
    title: i18n.t('tables:hotWeightSlaughter')
  },
  {
    align: 'right',
    name: 'boningoutinspectionnum',
    title: i18n.t('tables:boningSIF')
  },
  {
    align: 'right',
    name: 'boningoutat',
    title: i18n.t('tables:packingDate')
  },
  {
    align: 'right',
    name: 'productiondate',
    title: i18n.t('tables:deboningBatch')
  },
  {
    align: 'right',
    name: 'productionsif',
    title: i18n.t('tables:productionSIF')
  },
  {
    align: 'right',
    name: 'producedat',
    title: i18n.t('common:productionDate')
  },
  {
    align: 'right',
    name: 'buyorder',
    title: i18n.t('common:buyOrder')
  },
  {
    align: 'right',
    name: 'rawweight',
    title: i18n.t('tables:grossWeight')
  },
  {
    align: 'right',
    name: 'clearweight',
    title: i18n.t('tables:netWeight')
  },
  {
    align: 'right',
    name: 'qtt',
    title: i18n.t('common:qtyPieces')
  },
  {
    align: 'right',
    name: 'slaughtersif',
    title: i18n.t('tables:CNPJIndustrySlaughter')
  },
  {
    align: 'right',
    name: 'boningoutindustrycnpj',
    title: i18n.t('tables:CNPJDeboningIndustry')
  },
  {
    align: 'left',
    fixed: false,
    name: 'analyze',
    title: i18n.t('tables:analyze')
  },
  {
    align: 'left',
    fixed: false,
    name: 'skuorigin',
    title: i18n.t('tables:skuOrigin')
  },
  {
    align: 'left',
    fixed: false,
    name: 'productionsif',
    title: i18n.t('tables:productionSIF')
  },
  {
    align: 'left',
    fixed: false,
    name: 'contractmatrix',
    title: i18n.t('tables:contractMatrix')
  },
  {
    align: 'left',
    fixed: false,
    name: 'shippingmark',
    title: i18n.t('tables:shippingMark')
  },
  {
    align: 'left',
    fixed: false,
    name: 'healthcertificate',
    title: i18n.t('tables:healthCertificate')
  },
  {
    align: 'left',
    fixed: false,
    name: 'purchaseorder',
    title: i18n.t('tables:purchaseOrder')
  }
]

// Column name lists for each type
export const INNATURA_COLUMNS = [
  'order',
  'cargo',
  'industrydoc',
  'corporatename',
  'state',
  'city',
  'slaughterinspectionnum',
  'slaughteredat',
  'productcode',
  'productdescription',
  'slaughterbatch',
  'sequential',
  'band'
  // 'weight',
  // 'boningoutinspectionnum',
  // 'boningoutat',
  // 'productiondate'
]

export const PROCESSADOS_COLUMNS = [...INNATURA_COLUMNS]

export const DISTRIBUTION_COLUMNS = {
  viewer: ['order', 'slaughterinspectionnum', 'city', 'state', 'productionsif'],
  admin: [
    'order',
    'slaughterinspectionnum',
    'slaughteredat',
    'city',
    'state',
    'purchaseorder',
    'skuorigin',
    'productionsif',
    'contractmatrix',
    'shippingmark',
    'healthcertificate'
  ]
}

/**
 * Get columns filtered by business type
 * @param theme - Current theme (optional, used for conditional filtering)
 * @returns Filtered column list
 */
export const getColumnsByTheme = (
  theme: string,
  isAdmin: boolean
): ColumnsProps[] => {
  const allColumnsList = allColumns()

  const type = getLineTypeByTheme(theme)

  let columnNames: string[] = []

  switch (type) {
    case LINE_TYPES.INNATURA:
      columnNames = INNATURA_COLUMNS
      break
    case LINE_TYPES.PROCESSED:
      columnNames = PROCESSADOS_COLUMNS
      break
    case LINE_TYPES.DISTRIBUTION:
      columnNames = DISTRIBUTION_COLUMNS[isAdmin ? 'admin' : 'viewer']
      break
    default:
      return allColumnsList
  }

  return columnNames
    .map(name => allColumnsList.find(col => col.name === name))
    .filter(Boolean) as ColumnsProps[]
}

export const columns = (): ColumnsProps[] =>
  getColumnsByTheme(LINE_TYPES.INNATURA, false)
